import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, browserSessionPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || ''
};

// Verificação das variáveis de ambiente
if (!firebaseConfig.apiKey) {
  throw new Error('Variáveis de ambiente do Firebase não estão configuradas');
}

// Verificação específica para Database URL (obrigatória para Realtime Database)
if (!firebaseConfig.databaseURL || firebaseConfig.databaseURL === '') {
  console.warn('REACT_APP_FIREBASE_DATABASE_URL não está configurada. Realtime Database não funcionará.');
}

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);

// Só inicializar o database se a URL estiver configurada
export const database = firebaseConfig.databaseURL && firebaseConfig.databaseURL !== '' 
  ? getDatabase(app) 
  : null;

// Configurar persistência padrão como LOCAL para melhor experiência
// Garantir que a persistência seja sempre LOCAL por padrão
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Firebase Auth configurado com persistência LOCAL por padrão');
    
    // Configurar listener para monitorar mudanças de estado da autenticação
    auth.onAuthStateChanged((user) => {
      if (user) {
        
        // Renovar token periodicamente para manter a sessão ativa
        const renewToken = async () => {
          try {
            const token = await user.getIdToken(true);
            console.log('[Firebase] Token renovado automaticamente');
            
            // Atualizar o token no storage se existir dados do usuário
            const userData = JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user') || '{}');
            if (userData.id) {
              const storage = userData.rememberMe !== false ? localStorage : sessionStorage;
              storage.setItem('user', JSON.stringify({
                ...userData,
                token,
                lastActivity: Date.now()
              }));
            }
          } catch (error) {
            console.error('[Firebase] Erro ao renovar token:', error);
          }
        };
        
        // Renovar token a cada 50 minutos (antes dos 60 minutos padrão)
        setInterval(renewToken, 50 * 60 * 1000);
      } else {
        console.log('[Firebase] Usuário não autenticado');
      }
    });
  })
  .catch((error) => {
    console.error('Erro ao configurar persistência padrão:', error);
  });

// Configurar persistência do Firebase Auth
// Por padrão, SEMPRE usa LOCAL (persiste entre sessões do navegador)
// Mesmo quando o usuário não marca "Lembrar-me", mantemos LOCAL para melhor UX
export const setAuthPersistence = async (persistent = true) => {
  try {
    // SEMPRE usar LOCAL persistence para maximizar a duração da sessão
    // A diferença será controlada apenas pela duração da sessão no nosso app
    await setPersistence(auth, browserLocalPersistence);
    console.log(`Firebase Auth persistence SEMPRE configurado como LOCAL (melhor UX)`);
  } catch (error) {
    console.error('Erro ao configurar persistência do Firebase:', error);
    // Fallback para tentar configurar como SESSION se LOCAL falhar
    try {
      await setPersistence(auth, browserSessionPersistence);
      console.log('Firebase Auth configurado como SESSION (fallback)');
    } catch (fallbackError) {
      console.error('Erro ao configurar fallback de persistência:', fallbackError);
    }
  }
};
